// extracted by mini-css-extract-plugin
export default {"input":"SearchInput__input--1KO5h","searchIcon":"SearchInput__searchIcon--3rN55"};